import html2canvas from 'html2canvas'
import logoBadge from '../../../../../assets/smarttransyt-text-badge.png'
import {
  PHOTO_FRAME_WIDTH,
  PHOTO_FRAME_HEIGHT,
  LOGO_BOX_WIDTH,
  LOGO_BOX_HEIGHT,
  fittedImageRect,
  imageBoxSize
} from '../agent-photo-id-image-fit'

function paintFittedImage (source, boxWidth, boxHeight, fit, alignX, background) {
  const canvas = document.createElement('canvas')
  canvas.width = boxWidth
  canvas.height = boxHeight
  const context = canvas.getContext('2d')
  if (background) {
    context.fillStyle = background
    context.fillRect(0, 0, boxWidth, boxHeight)
  }
  const rect = fittedImageRect(source.naturalWidth, source.naturalHeight, boxWidth, boxHeight, fit, alignX)
  context.drawImage(source, rect.x, rect.y, rect.width, rect.height)
  return canvas.toDataURL('image/png')
}

function loadImageSrc (image, url) {
  return new Promise((resolve) => {
    image.onload = resolve
    image.onerror = resolve
    image.src = url
    if (image.complete) {
      resolve()
    }
  })
}

export default {
  name: 'agent-photo-id-card',
  props: {
    roleLabel: {
      type: String,
      default: ''
    },
    idNumber: {
      type: String,
      default: ''
    },
    fullName: {
      type: String,
      default: ''
    },
    photoSrc: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      logoSrc: logoBadge
    }
  },
  computed: {
    infoColor () {
      const theme = this.$vuetify && this.$vuetify.theme
      return theme && theme.info ? theme.info : '#2196F3'
    }
  },
  methods: {
    whenReady () {
      const images = this.$el.querySelectorAll('img')
      const waits = []
      for (let i = 0; i < images.length; i++) {
        const image = images[i]
        if (image.complete) {
          continue
        }
        waits.push(new Promise((resolve) => {
          image.onload = resolve
          image.onerror = resolve
        }))
      }
      return Promise.all(waits)
    },
    placeFittedImage (image, boxEl, fallbackWidth, fallbackHeight, fit, alignX, background) {
      if (!image || !image.naturalWidth || !image.naturalHeight) {
        return Promise.resolve()
      }
      const box = imageBoxSize(boxEl, fallbackWidth, fallbackHeight)
      const url = paintFittedImage(image, box.width, box.height, fit, alignX, background)
      image.style.width = box.width + 'px'
      image.style.height = box.height + 'px'
      image.style.left = '0px'
      image.style.top = '0px'
      return loadImageSrc(image, url)
    },
    async bakeImageRatios () {
      const photo = this.$el.querySelector('.photo-frame img')
      const logo = this.$el.querySelector('.logo img')
      await this.placeFittedImage(photo, this.$el.querySelector('.photo-frame'), PHOTO_FRAME_WIDTH, PHOTO_FRAME_HEIGHT, 'cover', 'center', '#ffffff')
      await this.placeFittedImage(logo, this.$el.querySelector('.logo'), LOGO_BOX_WIDTH, LOGO_BOX_HEIGHT, 'contain', 'center', '#ffffff')
    },
    async capture () {
      await this.whenReady()
      await this.bakeImageRatios()
      return html2canvas(this.$refs.card, {
        scale: 1,
        width: 1012,
        height: 638,
        backgroundColor: '#ffffff',
        logging: false,
        useCORS: true
      })
    }
  }
}
